document.addEventListener("DOMContentLoaded", () => {
	const rteElements = document.querySelectorAll('.prose');
	rteElements.forEach(el => {
		el.querySelectorAll('img').forEach((imgEl) => {
			if (imgEl.classList.contains('-align-left')) {
				imgEl.style.removeProperty('float');
				let pEl = imgEl.closest('p');
				if (pEl) {
					pEl.classList.add("clearfix");
				}
			}
			if (imgEl.classList.contains('-align-center')) {
				imgEl.style.removeProperty('display');
				imgEl.style.removeProperty('margin-left');
				imgEl.style.removeProperty('margin-right');
			}
			if (imgEl.classList.contains('-align-right')) {
				imgEl.style.removeProperty('float');
				let pEl = imgEl.closest('p');
				if (pEl) {
					pEl.classList.add("clearfix");
				}
			}
		});
		el.querySelectorAll('iframe').forEach((iframeEl) => {
			let divEl = iframeEl.closest('div[data-sf-ec-immutable].-sf-relative')
			if (divEl) {
				divEl.style.removeProperty('width');
				divEl.style.removeProperty('height');
			}
		});
	});

	document.querySelectorAll(".brand-swiper").forEach(function (s) {
		new Swiper(s, {			
			spaceBetween: 0,
			speed: 10000,
			direction: 'horizontal',
			autoplay: {
				delay: 0,
				disableOnInteraction: false
			},
			loop: true,
			slidesPerView: 1,
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
			}
		});
	});
});

document.addEventListener('alpine:init', () => {

	Alpine.store('pageHeaderFixedTop', {
		on: false,

		toggle() {
			this.on = !this.on
		},
		enable() {
			this.on = true;
		},
		disable() {
			this.on = false;
		}
	});

	Alpine.store('pageHeaderFixedBottom', {
		on: false,

		toggle() {
			this.on = !this.on
		},
		enable() {
			this.on = true;
		},
		disable() {
			this.on = false;
		}
	});

	Alpine.store('websiteHeader', {
		init() {
			Alpine.effect(() => {
				
			});
		},	
		open: false,
		transparency: false,
		transparencyEnabled: false,
		enableTransparency() {
			this.transparencyEnabled = true;
			if (window.scrollY == 0) {
				this.transparency = true;
			}			
		},
		toggleTransparency() {
			if (this.transparency) {
				this.turnOff(e);
			}
			else {
				this.turnOn(e);
			}
		},
		turnTransparencyOn() {
			if (this.transparencyEnabled && window.scrollY == 0) {
				this.transparency = true;
			}
		},
		turnTransparencyOff() {
			if (this.transparencyEnabled) {
				this.transparency = false;
			}
		},
		toggleHeader(e) {

			if (this.open) {
				this.closeHeader(e);
			}
			else {
				this.openHeader(e);
			}
		},
		openHeader(e) {			
			this.open = true;

			const list = ['overflow-hidden'];
			document.body.classList.add(...list);

			this.turnTransparencyOff();
		},
		closeHeader(e) {			
			this.open = false;

			const list = ['overflow-hidden'];
			document.body.classList.remove(...list);

			this.turnTransparencyOn();
		}			
	});

	Alpine.data('megaMenu', () => ({
		init() {			
			Alpine.effect(() => {
				
			});
		},
		navIndex: -1,
		isOpen: false,
		trapSupport: false,
		isTrapped(navIndex) {
			if (this.trapSupport) {
				return this.isOpen && this.navIndex == navIndex;
			}
			return false;			
		},
		toggleMenuItem(e, navIndex, level) {			
			if (this.navIndex == navIndex) {
				this.closeMenuItem(e, level);	
			}
			else {
				this.openMenuItem(e, navIndex, level);	
				this.trapSupport = true;
			}			
		},
		openMenuItem(e, navIndex, level) {
			this.navIndex = navIndex;
			this.isOpen = true;

			if (level == 1 && window.matchMedia('(min-width: 1280px)').matches) {
				Alpine.store('websiteHeader').turnTransparencyOff();
			}
		},
		closeMenuItem(e, level) {
			this.navIndex = -1;
			this.isOpen = false;
			this.trapSupport = false;

			if (level == 1 && window.matchMedia('(min-width: 1280px)').matches) {
				Alpine.store('websiteHeader').turnTransparencyOn();
			}
		},
		resetMenu(e) {
			this.navIndex = -1;
			this.isOpen = false;
			this.trapSupport = false;

			if (window.matchMedia('(min-width: 1280px)').matches) {
				Alpine.store('websiteHeader').turnTransparencyOn();
			}			
		}
	}));

	Alpine.data('pageHeader', (behindWebsiteHeader = false) => ({
		behindWebsiteHeader: false,
		init() {
			this.behindWebsiteHeader = behindWebsiteHeader;
			if (this.behindWebsiteHeader) {
				Alpine.store('websiteHeader').enableTransparency();												
			}
		}
	}));

	Alpine.data('sfRte', (el) => ({
		done: false,
		init() {
			if (this.done === false) {
				let bgEl = el.closest('[class^=bg-], [class*= bg-]');				
				if (bgEl) {
					if (bgEl.classList.contains('bg-primary-500')) {
						el.classList.add('prose-inverted-500');
					}
					else if (bgEl.classList.contains('bg-bordeaux-500')) {
						el.classList.add('prose-white');
					}
					else if (bgEl.classList.contains('bg-dark-blue-500')) {
						el.classList.add('prose-white');
					}
					else if (bgEl.classList.contains('bg-gray-500')) {
						
					}
					else if (bgEl.classList.contains('bg-red-500')) {
						el.classList.add('prose-white');
					}
					else if (bgEl.classList.contains('bg-yellow-500')) {
						
					}
				}				
				this.done = true;
			}
		}
	}));

	Alpine.data('sfNavigationLinks', (el) => ({
		done: false,
		init() {
			if (this.done === false) {
				let bgEl = el.closest('[class^=bg-], [class*= bg-]');
				if (bgEl) {
					if (bgEl.classList.contains('bg-primary-500')) {
						el.querySelectorAll('a').forEach((button) => {
							button.classList.remove('text-primary-500');
							button.classList.add('text-inverted-500');
						});
					}
					else if (bgEl.classList.contains('bg-bordeaux-500')) {
						el.querySelectorAll('a').forEach((button) => {
							
						});
					}
					else if (bgEl.classList.contains('bg-dark-blue-500')) {
						el.querySelectorAll('a').forEach((button) => {

						});
					}
					else if (bgEl.classList.contains('bg-gray-500')) {
						el.querySelectorAll('a').forEach((button) => {

						});
					}
					else if (bgEl.classList.contains('bg-red-500')) {
						el.querySelectorAll('a').forEach((button) => {

						});
					}
					else if (bgEl.classList.contains('bg-yellow-500')) {
						el.querySelectorAll('a').forEach((button) => {

						});
					}
					else if (bgEl.classList.contains('bg-black')) {
						el.querySelectorAll('a').forEach((button) => {
							button.classList.remove('text-primary-500');
							button.classList.add('text-white');
						});
					}
				}				
				this.done = true;
			}
		}
	}));

	Alpine.data('filters', () => ({
		open: false,
		disabled: false,
		init() {
			
		},
		openFilters() {			
			this.open = true;

			const list = ['overflow-hidden'];
			document.body.classList.add(...list);
		},
		closeFilters() {			
			this.open = false;

			const list = ['overflow-hidden'];
			document.body.classList.remove(...list);
		}	
	}));

	Alpine.data('footerNavCollapse', () => ({
		open: false,
		disabled: true,
		init() {
			const mediaQuery = window.matchMedia('(min-width: 640px)');
			this.open = mediaQuery.matches;
			this.disabled = mediaQuery.matches;

			mediaQuery.addEventListener("change", (e) => {
				this.open = e.matches;
				this.disabled = e.matches;
			});
		}
	}));
});